"use client";

import { useCurrentUrl } from "@/hooks/useCurrentUrl";
import Image from "next/image";

export function SocialShareIcons() {
  const url = useCurrentUrl();

  return (
    <div className="social-share mt-10">
      <p className="font-semibold font-roboto-serif mb-5">Share this story</p>

      <div className="social-platforms flex gap-x-5">
        {/*  Twitter  */}
        <a
          href={`https://twitter.com/intent/tweet?url=${url}`}
          aria-label="Share on Twitter"
          rel="noopener nofollow"
          target="_blank"
          className="w-6 h-6 relative inline-flex"
        >
          <Image
            src={"/icons/twitter-share.svg"}
            alt={""}
            className="object-cover object-center"
            fill
          />
        </a>

        {/*  Facebook  */}
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          aria-label="Share on Facebook"
          rel="noopener nofollow"
          target="_blank"
          className="w-6 h-6 relative inline-flex"
        >
          <Image
            src={"/icons/facebook-share.svg"}
            alt={""}
            className="object-cover object-center"
            fill
          />
        </a>

        {/*  Email   */}
        <a
          href={
            `mailto:?subject=I%20found%20this%20article%20on%20Photography%20News&body=` +
            `I%20thought%20you%20may%20be%20interested%0A%0A${encodeURIComponent(url)}`
          }
          rel="noopener"
          target="_blank"
          aria-label="Share on Email"
          className="w-6 h-6 relative inline-flex"
        >
          <Image
            src={"/icons/email-share.svg"}
            alt={""}
            className="object-cover object-center"
            fill
          />
        </a>

        {/*  Whatsapp  */}
        <a
          href={`https://api.whatsapp.com/send?text=Check%20out%20this%20article%20I%20found%20on%20Photography%20News%0A%0A${url}`}
          rel="noopener"
          target="_blank"
          aria-label="Share on Whatsapp"
          className="w-6 h-6 relative inline-flex"
        >
          <Image
            src={"/icons/whatsapp-share.svg"}
            alt={""}
            className="object-cover object-center"
            fill
          />
        </a>
      </div>
    </div>
  );
}
